module.exports = "../dist/img/img_1-18.0b6d.jpg";